<div class="pos-relative cursor-pointer"
     iCmsModalOpen="image-zoom-modal"
     [iCmsModalOpenData]="{model, products}">
    <!-- image -->
    <div class="overflow-hidden ratio-1-1">
        <local-shell />
        @switch (model.data.content_type) {
        <!--klevu trending products -->
        @case ('vimeo') {
        <vimeo-player [video-url]="model.data.url"
                      [background]="true"
                      class="bg-col-w _vimeo-player"
                      autoplay-in-viewport="true"
                      loop="true">
        </vimeo-player>
        }
        @default {
        <img class="rf"
             [image]="model.data.image" />
        }
        }
        <!-- profile name -->
        @if (model.data?.user_tag) {
        <p class="pos-absolute z-3 p2 col-w bottom-4 left-4 right-0">
            {{client.isS && model.data?.user_tag.length > 19 ?
            model.data?.user_tag.substring(0,19) + '...' : model.data?.user_tag}}</p>
        }
        <!-- overlay -->
        @if (!(client.isS)) {
        <div class="fill"
             style="background: rgba(0, 0, 0, 0.15);">
        </div>
        }
    </div>

    <!-- shop the look -->
    @if(products?.length > 0 && shopTheLook){
    <div [ngClass]="shopTheLookUnder ? 'flex flex-justify-center' : 'pos-absolute cursor-pointer z-2 fill flex flex-middle flex-justify-center _shop-the-look'"
         [ngStyle]="{'background-color': shopTheLookUnder ? 'transparent' : 'rgba(0, 0, 0, 0.15)'}">
        <div [ngClass]="shopTheLookUnder ? 'button-inline cursor-pointer p1 p-t-2' : 'button-2 m-r-2 m-l-2 p-l-2 p-r-2'">
            {{ 'Shop the look' | translate }}
        </div>
    </div>
    }
</div>